import { Avatar, Divider, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Skeleton } from '@mui/material';
import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUsers } from '../../api/index.js';

const MonitorsList = () => {
  const { data = [], isLoading } = useUsers();
  const navigate = useNavigate();

  return (
    <List sx={{ width: '100%', maxWidth: 450, bgcolor: 'background.paper' }}>
      {(isLoading ? Array.from(new Array(3)) : data).map((monitor, index) => (
        monitor ?
          <Fragment key={monitor.id}>
            <ListItemButton onClick={() => navigate(`/monitors/${monitor.id}`)}>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar alt={`${monitor.name}'s picture`} src={monitor.picture} />
                </ListItemAvatar>
                <ListItemText
                  primary={monitor.name}
                  secondary={monitor.email}
                />
              </ListItem>
            </ListItemButton>
            {index !== data.length - 1 ? <Divider variant="inset" component="li" /> : null}
          </Fragment>
          :
          <Skeleton key={index} height={88} width={450} animation={'wave'} />
      ))}
    </List>
  );
};

export default MonitorsList;
